import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Button from "@mui/material/Button";

import {
    useViewPostMutation,
    useTicketViewUrlQuery,
    TicketItemsResponse,
} from "../../api/filter";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { newFilter, Filter } from "./filterSlice";
//@ts-check
import { EditForm } from "./EditForm";
import TimeTable from "../time-table/TimeTable";
import { toTimeRows } from "../time-table/timeTableSlice";

export default function FilterView() {
    const { id } = useParams();
    return <FilterViewContent key={id} id={id!} />;
}
export function FilterViewContent({ id }: { id: string }) {
    let filter = newFilter();
    //filter.level_4 = true;
    filter.level_5 = true;
    if (id === "1") {
        filter.tags_or = ["priv", "protos", "fin", "fdoe"]; //["priv", "fin", "fdoe", "protos"];
    } else {
        filter.tags_or = ["pro"];
    }
    const dispatch = useAppDispatch();

    // Prevent double post in React 18 StrictMode dev
    const ranOnce = useRef(false);
    let [fr, setFr] = React.useState<Filter | null>(filter);
    const [viewPost, { data, isLoading, isError, error, isSuccess, reset }] =
        useViewPostMutation();
    useEffect(() => {
        if (ranOnce.current) return;
        ranOnce.current = true;

        // fire-and-forget (or await inside an async IIFE)
        (async () => {
            try {
                await viewPost(filter).unwrap();
            } catch {
                // error state is already populated in `error`
            }
        })();

        // optional cleanup: if component unmounts, you may want to reset
        return () => {
            reset();
        };
    }, [viewPost, reset]);

    const onApply = () => {
        if (fr) {
            viewPost(fr)
                .unwrap()
                .then((fullfilled) => {
                    if (fullfilled && fullfilled.ticket_items) {
                        //navigate(
                        //    "/ticket/view/" + fullfilled.ticket.metadata.id,
                        //);
                    }
                });
        }
    };
    return (
        <>
            - priv all {id}, - priv, - fin, - fdoe, - protos, ?
            <br />
            <br />
            <Button variant="contained" onClick={onApply}>
                Apply
            </Button>
            <br />
            <EditForm
                onFFChange={(filter: Filter) => {
                    setFr(filter);
                }}
                onSave={() => {}}
                ff={filter}
            />
            {data && <DisplayResult data={data} />}
        </>
    );
}

type DisplayResultProps = {
    data: TicketItemsResponse;
};
function DisplayResult(data: DisplayResultProps) {
    let dat = toTimeRows(Object.values(data.data.ticket_items));
    //let dat = toTimeRows(data.data.ticket_items);
    return (
        <>
            <TimeTable
                data={dat}
                refDate={new Date()}
                linkTo={"parent"}
                titleLink={(id: string) => "/ticket/view/" + id}
            />
        </>
    );
}
